// // import { useEffect, useState, useRef } from 'react';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import axiosInstance from '../api/axios';
// // import { Container, Typography, CircularProgress } from '@mui/material';

// // const SignupSuccess = () => {
// //     const [loading, setLoading] = useState(true);
// //     const [errorMessage, setErrorMessage] = useState('');
// //     const navigate = useNavigate();
// //     const location = useLocation();
// //     const isSignupInProgress = useRef(false);

// //     useEffect(() => {
// //         const handleUserSignup = async () => {
// //             if (isSignupInProgress.current) return;
// //             isSignupInProgress.current = true;
// //             try {
// //                 const userDetails = JSON.parse(localStorage.getItem('userDetails'));
// //                 if (userDetails) {
// //                     const { full_name, email, password, ip , fingerprint ,isGoogle, googleId } = userDetails;
// //                     const queryParams = new URLSearchParams(location.search);
// //                     const customer_id = queryParams.get('customer_id');

// //                     if (!customer_id) {
// //                         setErrorMessage('Invalid customer_id or missing user information. Please restart the signup process.');
// //                         setLoading(false);
// //                         return;
// //                     }

// //                      const signupResponse = await axiosInstance.post("/signup", {
// //                         full_name,
// //                         email,
// //                         customer_id,
// //                         password,
// //                         fingerprint,
// //                         ip,
// //                         isGoogle,
// //                         googleId

// //                     });

// //                     if (signupResponse.data.message) {
// //                         localStorage.removeItem('userDetails');
// //                         navigate("/login");
// //                     } else {
// //                         setErrorMessage('Failed to create the user. Please try again.');
// //                     }
// //                 } else {
// //                     setErrorMessage('User details are missing. Please restart the signup process.');
// //                     setLoading(false);
// //                 }
// //             } catch (error) {
// //                 console.error('Error during signup:', error);
// //                 setErrorMessage('An error occurred while creating your account.');
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         handleUserSignup();
// //     }, [navigate, location]);

// //     return (
// //         <Container maxWidth="sm" sx={{ paddingTop: 4 }}>
// //             {loading ? (
// //                 <Typography variant="h6" align="center">
// //                     <CircularProgress sx={{ marginBottom: 2 }} />
// //                     Processing your account...
// //                 </Typography>
// //             ) : errorMessage ? (
// //                 <Typography color="error" variant="body2" align="center">
// //                     {errorMessage}
// //                 </Typography>
// //             ) : (
// //                 <Typography variant="h6" align="center">
// //                     Account successfully created! Welcome!
// //                 </Typography>
// //             )}
// //         </Container>
// //     );
// // };

// // export default SignupSuccess;

// import { useEffect, useState, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axiosInstance from "../api/axios";
// import { Container, Typography, CircularProgress } from "@mui/material";

// const SignupSuccess = () => {
//   const [loading, setLoading] = useState(true);
//   const [errorMessage, setErrorMessage] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation();
//   const isSignupInProgress = useRef(false);

//   useEffect(() => {
//     const finalizeSignup = async () => {
//       if (isSignupInProgress.current) return;
//       isSignupInProgress.current = true;

//       try {
//         const queryParams = new URLSearchParams(location.search);
//         const sessionToken = queryParams.get("session_token");
//         const customer_id = queryParams.get("customer_id");

//         if (!sessionToken) {
//           setErrorMessage(
//             "Missing session token. Please restart the signup process."
//           );
//           setLoading(false);
//           return;
//         }

//         const response = await axiosInstance.post("/signup", {
//           session_token: sessionToken,
//           customer_id: customer_id,
//         });

//         if (
//           response.data.message ===
//           "User signed up successfully with free trial"
//         ) {
//           navigate("/login");
//         } else {
//           setErrorMessage("Failed to create the user. Please try again later.");
//         }
//       } catch (error) {
//         console.error("Error finalizing signup:", error);
//         setErrorMessage(
//           error.response?.data?.detail ||
//             "An error occurred while creating your account."
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     finalizeSignup();
//   }, [navigate, location]);

//   return (
//     <Container maxWidth="sm" sx={{ paddingTop: 4 }}>
//       {loading ? (
//         <Typography variant="h6" align="center">
//           <CircularProgress sx={{ marginBottom: 2 }} />
//           Processing your account...
//         </Typography>
//       ) : errorMessage ? (
//         <Typography color="error" variant="body2" align="center">
//           {errorMessage}
//         </Typography>
//       ) : (
//         <Typography variant="h6" align="center">
//           Account successfully created! Welcome!
//         </Typography>
//       )}
//     </Container>
//   );
// };

// export default SignupSuccess;

import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../api/axios";
import { motion } from "framer-motion";
import logo from "../images/logo.png";

const SignupSuccess = () => {
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const isSignupInProgress = useRef(false);

  useEffect(() => {
    const finalizeSignup = async () => {
      if (isSignupInProgress.current) return;
      isSignupInProgress.current = true;

      try {
        const queryParams = new URLSearchParams(location.search);
        const sessionToken = queryParams.get("session_token");
        const customer_id  = queryParams.get("customer_id");

        if (!sessionToken) {
          setErrorMessage("Missing session token. Please restart the signup process.");
          setStatus("error");
          return;
        }

        const response = await axiosInstance.post("/signup", {
          session_token: sessionToken,
          customer_id,
        });

        if (response.data.message === "User signed up successfully with free trial") {
          setStatus("success");
          // Give the user a moment to see the success state, then redirect
          setTimeout(() => navigate("/furhome"), 2500);
        } else {
          setErrorMessage("Failed to create your account. Please try again.");
          setStatus("error");
        }
      } catch (error) {
        console.error("Error finalizing signup:", error);
        setErrorMessage(
          error.response?.data?.detail || "An error occurred while creating your account."
        );
        setStatus("error");
      }
    };

    finalizeSignup();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-[#faf7f5] flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-10"
      >
        <img src={logo} alt="Furbabies.AI" className="w-28 h-28 mx-auto" />
      </motion.div>

      {/* ── Loading ── */}
      {status === "loading" && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm px-10 py-12 max-w-md w-full text-center"
        >
          <div className="w-14 h-14 border-4 border-[#967d6c] border-b-transparent rounded-full animate-spin mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Setting up your account</h2>
          <p className="text-gray-500 poppins-text text-sm">
            We're confirming your payment and creating your account. This only takes a moment…
          </p>
        </motion.div>
      )}

      {/* ── Success ── */}
      {status === "success" && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm px-10 py-12 max-w-md w-full text-center"
        >
          {/* Checkmark */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 400, damping: 20, delay: 0.1 }}
            className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6"
          >
            <svg className="w-8 h-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </motion.div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">Welcome to Furbabies.AI!</h2>
          <p className="text-gray-500 poppins-text text-sm mb-6">
            Your account is ready. Taking you to your login…
          </p>

          {/* Progress bar */}
          <div className="w-full bg-gray-100 rounded-full h-1.5 overflow-hidden">
            <motion.div
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 2.5, ease: "linear" }}
              className="h-full bg-[#967d6c] rounded-full"
            />
          </div>
        </motion.div>
      )}

      {/* ── Error ── */}
      {status === "error" && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white border border-[#e8ddd6] rounded-2xl shadow-sm px-10 py-12 max-w-md w-full text-center"
        >
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">Something went wrong</h2>
          <p className="text-gray-500 poppins-text text-sm mb-8">{errorMessage}</p>

          <div className="flex flex-col gap-3">
            <motion.button
              whileHover={{ backgroundColor: "#BDA697" }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate("/signup")}
              className="w-full bg-[#967d6c] text-white py-3 rounded-xl poppins-text font-medium text-sm"
            >
              Try signing up again
            </motion.button>
            <motion.button
              whileHover={{ backgroundColor: "#f0e9e4" }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate("/")}
              className="w-full bg-white border border-[#e8ddd6] text-gray-600 py-3 rounded-xl poppins-text text-sm"
            >
              Back to home
            </motion.button>
          </div>

          <p className="mt-6 text-xs text-gray-400 poppins-text">
            If you were charged, please contact us and we'll resolve it immediately.
          </p>
        </motion.div>
      )}
    </div>
  );
};

export default SignupSuccess;